import { kTriAnnoW } from "../constants";
import { XML_AdjustLineWidth } from "./XML_AdjustLineWidth";
import { XML_ShiftRect } from "./XML_ShiftRect";
import { XML_DrawAnnoLabel } from "./XML_DrawAnnoLabel";
import { XML_DrawTri } from "./XML_DrawTri";

export function XML_RenderAnno(
  bounds,
  boxShape,
  triColor,
  dashColor,
  subTriColor,
  annoLabel,
  triPosition,
  borderColor,
  borderThickness,
  drawElement,
  layer
) {
  var raw_bounds = bounds.Clone();
  XML_ShiftRect(bounds, drawElement, layer);
  borderThickness = XML_AdjustLineWidth(borderThickness, drawElement, layer);

  bounds.fTop = drawElement.ConvertY(bounds.fTop);
  bounds.fBottom = drawElement.ConvertY(bounds.fBottom);

  XML_DrawTri(
    bounds,
    boxShape,
    borderThickness,
    triColor,
    triPosition,
    borderColor,
    dashColor,
    subTriColor,
    drawElement,
    layer
  );

  if (annoLabel)
    XML_DrawAnnoLabel(annoLabel, raw_bounds, kTriAnnoW, triColor, triPosition, drawElement, layer);
}
